// Components
import { Icon, TextAreaInput } from '@octano/global-ui';
import { Col, UncontrolledTooltip } from 'reactstrap';

// Hooks
import { useFormContext } from 'react-hook-form';

// I18n
import { useTranslation } from 'react-i18next';

// Types
import { OfferDetailsFormFields } from '../types';
import LengthCounter from '../../../../../components/Form/LengthCounter';
import { TEXTAREA_MAXLENGTH } from '../../../../../config/constants';
const prefix = 'views.addOffer.offerDetails';

// Render
const OfferDescriptionSection = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<OfferDetailsFormFields>();

  return (
    <>
      <Col xs={12} className="mt-5">
        <div className="d-flex align-conent-center align-items-center">
          <h5 className="text-primary fs-20 fw-700 mb-0 mr-2 text-uppercase">
            {t(`${prefix}.offerDescriptionSection.title`)}
          </h5>
          <span id="offerDescriptionInformation">
            <Icon name="information" />
          </span>
          <UncontrolledTooltip
            placement="right"
            target={'offerDescriptionInformation'}
            fade={false}
          >
            {t(`${prefix}.offerDescriptionSection.information`)}
          </UncontrolledTooltip>
        </div>
      </Col>
      <Col xs={12}>
        <TextAreaInput
          label=""
          name="offerDescription"
          placeholder={t(`${prefix}.addADescription`)}
          control={control}
          rules={{ required: t('common.validations.required') }}
          maxLength={TEXTAREA_MAXLENGTH}
        />
        <LengthCounter name="offerDescription" />
      </Col>
    </>
  );
};

export default OfferDescriptionSection;
